

<template>
  <div></div>
    </template>
    
    
    <script>
    export default {
      components: {
   
      },
      data() {
        return {

        }
      },
      computed: {
      },
      created() {
        this.getEuroclassFibre();
        },

    methods: {
      getEuroclassFibre(){

     
      
        this.obj = {
          'cable' : {
            'euroclass' : {
              pkEuroclass: 4,
              codeRefEuroclass: "",
              nomEuroclass: "Non applicable"
        }
      }};

      this.$store.commit('SET_CHOICE_CABLE', this.obj )

    }

    },
    
    
    }
    </script>